// extracted by mini-css-extract-plugin
export default {"indexCard":"IndexCard-module__indexCard--FRu5B"};